/* Zermira favoriler: cihazda (localStorage) ürün handle listesi tutar; kalp butonları, sayaçlar ve favoriler sayfası */
(function () {
  if (window.zrWish) return;
  var K = 'zr-wish';
  function get() { try { return JSON.parse(localStorage.getItem(K)) || []; } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(K, JSON.stringify(a.slice(0, 60))); } catch (e) {} sync(); }
  function sync() {
    var a = get();
    /* Yalnız değişen değeri yaz: textContent her yazılışta childList değişimi üretip aşağıdaki
       MutationObserver'ı yeniden tetikliyordu → 120 ms'de bir sonsuz döngü (23.10) */
    document.querySelectorAll('[data-zr-wish]').forEach(function (b) {
      var on = a.indexOf(b.getAttribute('data-zr-wish')) > -1, p = on ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') === p) return;
      b.setAttribute('aria-pressed', p);
      b.setAttribute('aria-label', on ? 'Favorilerden çıkar' : 'Favorilere ekle');
    });
    var n = String(a.length);
    document.querySelectorAll('.zr-wish-count').forEach(function (c) {
      if (c.textContent !== n) c.textContent = n;
      if (c.hidden !== !a.length) c.hidden = !a.length;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-zr-wish]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var a = get(), h = b.getAttribute('data-zr-wish'), i = a.indexOf(h);
    if (i > -1) { a.splice(i, 1); }
    else { a.unshift(h); b.classList.add('zr-wish--pop'); setTimeout(function () { b.classList.remove('zr-wish--pop'); }, 450); }
    save(a);
    if (i === -1) toast();
    document.dispatchEvent(new CustomEvent('zr:wish', { detail: { handle: h, added: i === -1 } }));
  }, true);
  /* Eklenince kısa şerit: müşteri listenin yerini öğrensin. Favoriler sayfasında gösterilmez. */
  var tEl, tHide;
  function toast() {
    if (location.pathname.indexOf('/pages/favoriler') === 0) return;
    if (!tEl) {
      tEl = document.createElement('div');
      tEl.className = 'zr-wtoast';
      tEl.setAttribute('role', 'status');
      tEl.setAttribute('aria-live', 'polite');
      tEl.innerHTML = '<span class="zr-wtoast__t"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3 4.7 13a4.6 4.6 0 0 1 6.5-6.5l.8.8.8-.8A4.6 4.6 0 0 1 19.3 13z" fill="currentColor"/></svg>Favorilere eklendi</span><a class="zr-wtoast__a" href="/pages/favoriler">Favorilerim →</a>';
      document.body.appendChild(tEl);
    }
    var bar = document.querySelector('[id^="zrsatc-"].is-visible');
    tEl.style.bottom = bar ? 'calc(' + (bar.offsetHeight + 12) + 'px + env(safe-area-inset-bottom, 0px))' : '';
    clearTimeout(tHide);
    tEl.classList.remove('is-on'); void tEl.offsetWidth; tEl.classList.add('is-on');
    tHide = setTimeout(function () { tEl.classList.remove('is-on'); }, 3800);
  }
  var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(sync, 120); })
    .observe(document.documentElement, { childList: true, subtree: true });
  window.zrWish = { get: get, save: save, sync: sync };
  if (document.readyState !== 'loading') sync(); else document.addEventListener('DOMContentLoaded', sync);
})();
